<section class="empty-filter-state" aria-live="polite">
  <div class="empty-filter-state-icon">
    <lucide-angular name="folder-x"></lucide-angular>
  </div>
  <p class="empty-filter-state-title">{{ title }}</p>
  <p class="empty-filter-state-text">{{ message }}</p>
</section>
